<template>
  <div>
    <a-tree
      showLine
      :treeData="treeData"
      :expandedKeys="expandedKeys"
      @expand="handleOpen"
    >
      <template slot="canEditLabel" slot-scope="labelItem" >
        <a-input v-show="labelItem.editing" size="small" v-model="labelItem.label_name" @keyup.enter="handleSave(labelItem)"/>
        <a-dropdown :trigger="['contextmenu']" v-show="!labelItem.editing" >
          <span style="user-select: true" @click="toggleEdit(labelItem)">{{ labelItem.label_name }}</span>
          <a-menu slot="overlay">
            <a-menu-item key="addnext" @click="handleAddNext(labelItem)">添加同一级</a-menu-item>
            <a-menu-item key="edit" @click="handleEdit(labelItem)">修&nbsp;&nbsp;&nbsp;改</a-menu-item>
            <a-menu-item key="addchild" @click="handleAddChild(labelItem)">添加下一级</a-menu-item>
            <a-menu-item key="delete" @click="handleDelete(labelItem)">删&nbsp;&nbsp;&nbsp;除</a-menu-item>
          </a-menu>
        </a-dropdown>
      </template>
    </a-tree>
  </div>
</template>

<script>
import { getLabelList, createLabel, updateLabel, deleteLabel } from '@/api/label'

var isDoubleClick = false
function formatToTreeData (LabelTrees, place) {
  //debugger
  const node = new Array()
  var i = 0
  if(LabelTrees.length == 0) return []
  LabelTrees.map(item => {
    var placeArray = place.concat(i)
    
    node.push({
      key: item.label_id, // 138
      label_name: item.label,

      children: formatToTreeData(item.children, placeArray),
      place: placeArray,
      edit: false,
      saved: true,
      scopedSlots: { title: 'canEditLabel' }
    })
    i++
  })
  return node
}

function searchForItem (tree, place) {
  var target = tree[place[0]]
  var parent = null
  for (var i = 1; i < place.length; i++) {
    parent = target
    target = target.children[place[i]]
  }
  return {
    current: target,
    parent: parent
  }
}

export default {
  name: 'LabelTrees',
  data () {
    return {
      treeData: [],
      selectedItem: null,
      expandedKeys: [],
      projectId: '',
      fetchType: ''
    }
  },
  props: {
    labelType: {
      type: Number,
      default: 0,
      required: true,
    }
  },
  mounted () {
    this.projectId = this.$store.getters.projectId
    if (this.labelType == 1) {
      this.fetchType = 'FetchGlobalLabelTrees'
      this.treeData = this.$store.getters.globalLabelTrees
    }
    if (this.labelType == 2) {
      this.fetchType = 'FetchLocalLabelTrees'
      this.treeData = this.$store.getters.localLabelTrees
    }
    //debugger
    if (this.treeData.length == 0) {
      const _this = this
      this.$store.dispatch(this.fetchType).then(labelData => {
        //debugger
        if (labelData.labelTrees == undefined) {
          _this.treeData.push({
            key: '', // label_ids
            label_name: '',
            children: [],
            place: [0],
            editing: true,
            saved: false,
            scopedSlots: { title: 'canEditLabel' }
          })
        } else _this.treeData = formatToTreeData(labelData.labelTrees, [])
      })
    }else this.treeData = formatToTreeData(this.treeData, [])
  },
  methods: {
    handleAddChild (labelItem) {
      const { current } = searchForItem(this.treeData, labelItem.place)
      current.children.push({
        key: '', // label_id
        label_name: '',

        children: [],
        place: labelItem.place.concat(labelItem.children.length),
        editing: true,
        saved: false,
        scopedSlots: { title: 'canEditLabel' }
      })
      if (this.expandedKeys.includes(current.key) == false) this.expandedKeys.push(current.key)
      // this.$set(item, 'label_name',  )
    },
    handleAddNext (labelItem) {
      const { parent } = searchForItem(this.treeData, labelItem.place)
      if (parent == null) {
        this.treeData.push({
          key: '', // label_id
          label_name: '',
          children: [],
          place: [this.treeData.length],
          editing: true,
          saved: false,
          scopedSlots: { title: 'canEditLabel' }
        })
      } else {
        parent.children.push({
          key: '', // label_id
          label_name: '',
          children: [],
          place: parent.place.concat(parent.children.length),
          editing: true,
          saved: false,
          scopedSlots: { title: 'canEditLabel' }
        })
        if (this.expandedKeys.includes(parent.key) == false) this.expandedKeys.push(current.key)
      }
    },
    handleEdit (labelItem) {
      const { current } = searchForItem(this.treeData, labelItem.place)
      this.$set(current, 'editing', !current.editing)
    },
    handleDelete (labelItem) {
      debugger
      const _this = this
      deleteLabel(labelItem.key)
        .then(res => {
          debugger
          if (res.code == '200') {
            const { current, parent } = searchForItem(this.treeData, labelItem.place)
            const index = current.place[current.place.length - 1]
            if (parent)parent.children.splice(index, 1)
            else _this.treeData.splice(index, 1)
            _this.$store.dispatch(this.fetchType)
          } else throw ''
        }).catch(() => {
          _this.$Message.info('删除失败')
        })
    },
    handleOpen (val) {
      this.expandedKeys = val
    },
    handleSave (labelItem) {
      const { current, parent } = searchForItem(this.treeData, labelItem.place)
      const saved = current.saved
      if (saved == false) var request = createLabel
      else var request = updateLabel
      const params = {
        parent_label_id: parent ? parent.key : 0,
        label_name: current.label_name,
        item_id: this.projectId,
        label_type: this.labelType,
        label_id: current.key
      }
      const _this = this
      request(params).then(res => {
        if (res.code == '200') {
          _this.$set(current, 'editing', false)
          _this.$set(current, 'key', res.data.label_id)
          _this.$set(current, 'saved', true)
          _this.$store.dispatch(this.fetchType)
        } else throw ''
      }).catch(() => {
        if (saved) _this.$Message.info('修改失败')
        else _this.$Message.info('创建失败')
      })
    },
    toggleEdit (labelItem) {
      if (isDoubleClick == false) {
        isDoubleClick = true
        setTimeout(() => { isDoubleClick = false }, 300)
        return
      }
      this.handleEdit(labelItem)
    }
  }
}
</script>
